import script from "./href-target.vue?vue&type=script&lang=ts&setup=true"
export * from "./href-target.vue?vue&type=script&lang=ts&setup=true"

import "./href-target.vue?vue&type=style&index=0&id=48ceb580&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ceb580"]])

export default __exports__